import axios from 'axios';

export const COUNTRIES = 'locations';

export function getCountries(params) {
  return axios.get(COUNTRIES, { params: params });
}
